import { render, staticRenderFns } from "./TravelGroupReportRecords.vue?vue&type=template&id=11ba87f6&"
import script from "./TravelGroupReportRecords.vue?vue&type=script&lang=js&"
export * from "./TravelGroupReportRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports